import FactoryComponents from '../../../../../../factory/components/FactoryComponents.js';
import moment from "moment";
import ProcessWorkPermitSelectPopup from '../../workPermit/ProcessWorkPermitSelectPopup.vue';

const root = {}
export default root
root.name = 'processWorkPermitDZ';
root.props = {
	initUserData: Object,
	areaData: Object,
	operaDataCache: Object,
	workerSelect: Array,
	applicantSelect: Array,
	departmentSelect: Array
}
root.components = {
	ProcessWorkPermitSelectPopup
}
root.data = {
	workPermitDZData: {
		isShowProcessWorkPermitSelectPopup: false,
		preWorkInfo: [],
		headerDataCache: {
			//作业证编号
			no: '',
			//作业证名称
			name: new Date().getTime(),
			//计划开始时间
			planStartTime: '',
			//计划结束时间
			planEndTime: '',
			//区域id
			locationId: 0,
			departmentId:0,
			//作业地点
			place: '',
			acceptanceEmpId: Number(localStorage.getItem("empId")), // 完工验收人id
			acceptanceOpinion: '',	//完收验工意见
			reviewEmpId: Number(localStorage.getItem("empId")), // 复核人id
			reviewOpinion: '',	//复核人意见
			jobExecutorEmpId: 0,//TODO 作业人id
			applyUserId: Number(localStorage.getItem("empId")), // 申请人id
			applyTime: moment().format('YYYY-MM-DD HH:mm:ss'),//申请作业时间
			contractorId: null, // 申请单位id
			certificateTypeId: 10,//作业票分类
		},

		//操作的缓存数据
		operaDataCache: {
			//吊装工具
			toolName: '',
			//吊装人员作业证编号
			workerNo: '',
			//吊装指挥作业人编号
			commandNo: '',
			//吊装作业监护人
			guardian: '',
			//起吊重物质量
			lw: '',
			//吊装内容
			content: '',
			//危险辨识
			hi: '',
			//安全措施
			sms: [],
			//安全交底人
			aqjdrId: 0,
			//接受交底人
			jsjdrId: 0,
			companyCharger: 0,//作业单位负责人
			companyChargerComment: '',//作业单位负责人意见
			prodSafetyCharger: 0,//生产单位安全部门负责人
			prodSafetyChargerComment: '',//生产单位安全部门负责人意见
			workSafetyCharger: 0,//作业单位安全部门负责人
			workSafetyChargerComment: '',//作业单位安全部门负责人
			branchCharger: 0,//生产车间(分厂)负责人负责人
			branchChargerComment: '',//生产车间(分厂)负责人意见
			approveCharger: 0,//审批部门负责人
			approveChargerComment: '',//审批部门负责人意见
			riskGrade: 0
		},
	}
}

root.methods = {
	//格式化选择的涉及的其他特殊作业及编号
	formatPreWorkInfo: function () {
		let data = []
		for (var i = 0; i < this.workPermitDZData.preWorkInfo.length; i++) {
			let element = this.workPermitDZData.preWorkInfo[i]
			data.push(`${element.name}(${element.no})`)
		}

		data = data.join(',')
		return data
	},
	//获取选择的涉及的其他特殊作业及编号
	getWorkPermitData: function (e) {
		this.workPermitDZData.preWorkInfo = []
		e.forEach(element => {
			element.selectData.forEach(item => {
				this.workPermitDZData.preWorkInfo.push({ 'no': item.no, 'name': item.name })
			});
		});
		this.$store.commit('setPreWorkInfo', this.workPermitDZData.preWorkInfo)
		this.workPermitDZData.isShowProcessWorkPermitSelectPopup = false

	},
	toOpenWorkCodePopup: function () {
		this.workPermitDZData.isShowProcessWorkPermitSelectPopup = true
	},
	returnCacheData: function () {
		return { ...this.workPermitDZData.headerDataCache, hoistingPropsDto: this.workPermitDZData.operaDataCache };
	},

	// 解析业务字段，编辑时按新增页默认字段补齐
	fillPermitData: function (data, preserveWhenMissing) {
		data = data || {};
		this.workPermitDZData.headerDataCache = { ...this.workPermitDZData.headerDataCache, ...data };
		let businessData = {};
		if (data.businessJson) {
			if (typeof data.businessJson === 'object') {
				businessData = data.businessJson;
			} else {
				try {
					businessData = JSON.parse(data.businessJson);
				} catch (e) {
					businessData = {};
				}
			}
		}
		this.workPermitDZData.operaDataCache = { ...this.workPermitDZData.operaDataCache, ...businessData };
		if (!Array.isArray(this.workPermitDZData.operaDataCache.sms) || !this.workPermitDZData.operaDataCache.sms.length) {
			this.workPermitDZData.operaDataCache.sms = [];
			this.getPermitTypeData();
		}
		this.backfillPreWorkInfo(data, preserveWhenMissing);
	},
	// 回填涉及的其他特殊作业及编号
	backfillPreWorkInfo: function (data, preserveWhenMissing) {
		const hasPreWorkInfo = data && Object.prototype.hasOwnProperty.call(data, 'preWorkInfo');
		if (!hasPreWorkInfo && preserveWhenMissing) {
			this.$store.commit('setPreWorkInfo', this.workPermitDZData.preWorkInfo);
			return;
		}
		let preWorkInfo = hasPreWorkInfo ? data.preWorkInfo : [];
		if (typeof preWorkInfo === 'string') {
			try {
				preWorkInfo = preWorkInfo ? JSON.parse(preWorkInfo) : [];
			} catch (e) {
				preWorkInfo = [];
			}
		}
		if (!Array.isArray(preWorkInfo)) {
			preWorkInfo = [];
		}
		this.workPermitDZData.preWorkInfo = preWorkInfo;
		this.$store.commit('setPreWorkInfo', preWorkInfo);
	},

	//数据回填
	dataBackfill: function (data) {
		this.fillPermitData(data, true);
	},
	//获取作业证中的sms
	getPermitTypeData: function () {
		const self = this;
		self.componentsMoudel.startPost('/safetyMeasures/list_all', { permitType: 7 }, true).then(res => {
			self.workPermitDZData.operaDataCache.sms = res.body.data;
		});
	}
}

root.mounted = function () {
	if (this.operaDataCache.businessJson) {
		this.fillPermitData(this.operaDataCache);
	} else {
		this.workPermitDZData.operaDataCache.sms = [];
		this.backfillPreWorkInfo(this.operaDataCache);
		this.getPermitTypeData();
	}
}
FactoryComponents.initComponent(root);
